import React, { useState, useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';

const ResetPasswordPage = ({ onResetPassword, isLoading, resetMessage, resetError, onBack }) => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [token, setToken] = useState(null);
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    // Extract token from URL (e.g., ?token=your_reset_token)
    const params = new URLSearchParams(window.location.search);
    const urlToken = params.get('token');
    if (urlToken) {
      setToken(urlToken);
    } else {
      setLocalError('Password reset token not found in URL.');
    }
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLocalError(null);

    if (password !== confirmPassword) {
      setLocalError('Passwords do not match.');
      return;
    }
    if (password.length < 6) {
      setLocalError('Password must be at least 6 characters long.');
      return;
    }
    if (token) {
      onResetPassword({ token, newPassword: password });
    } else {
      setLocalError('Password reset token is missing.');
    }
  };

  return (
    <div className="login-page"> {/* Reusing login-page styles for consistency */}
      {onBack && (
        <button className="back-to-home" onClick={onBack}>
          <ArrowLeft size={18} />
          <span className="btn-text">Back to Home</span>
        </button>
      )}
      
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-logo">
            <img src="/logo.ico" alt="LogHog" className="auth-logo-icon" />
            <div className="auth-logo-separator"></div>
            <span>THE LOGGING TOOL FOR EVERYONE</span>
          </div>
          
          <h2 className="auth-title">Reset Your Password</h2>
          <p className="auth-subtitle">
            Enter your new password below. Ensure it's at least 6 characters long.
          </p>
          
          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label htmlFor="new-password">New Password</label>
              <input
                id="new-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="confirm-password">Confirm New Password</label>
              <input
                id="confirm-password"
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>
            
            {(localError || resetError) && <p className="auth-error">{localError || resetError}</p>}
            {resetMessage && <p className="auth-success">{resetMessage}</p>}
            
            <div className="auth-button-container">
              <button type="submit" className="auth-button" disabled={isLoading || !token}>
                {isLoading ? 'Resetting...' : 'Reset Password'}
              </button>
            </div>
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
